import {
  Component,
  EventEmitter,
  Output,
  Input,
  SimpleChanges,
} from "@angular/core";
import { getSelectedPeriodBasis } from "@va/core-library/period-filter";
import {
  getPeriodTypeDataId,
  getSelectedPeriods,
} from "src/app/utils/period-utils";

@Component({
  selector: "app-drug-distribution-analysis-grid-controls",
  templateUrl: "./drug-distribution-analysis-grid-controls.component.html",
  styleUrls: ["./drug-distribution-analysis-grid-controls.component.scss"],
})
export class DrugDistributionAnalysisGridControlsComponent {
  @Input() defaultPeriodObj;
  @Input() selectedCurrency = "Base";
  @Input() periodRange = [];
  @Input() dataView = {
    view_by: ["values"],
    revision: "",
  };
  @Output() dataSettingsChanged: EventEmitter<any> = new EventEmitter();
  @Output() onReset: EventEmitter<any> = new EventEmitter();
  // @Output() cascaderValueChange = new EventEmitter<any>();
  @Input() selectedLIValue: any;

  //Period filter
  periodObj = {
    period: [],
    periodStart: -2,
    periodEnd: 7,
    period_type: "absolute",
    period_basis: "fiscal",
  };
  periodMinMax = {
    min: -15,
    max: 25,
  };

  //Currency filter
  currencyDisabled = false;
  apiEP: string = window.apiUrl;

  ngOnInit() {
    this.periodObj = {
      period: getSelectedPeriods(this.defaultPeriodObj, false),
      periodStart: -2,
      periodEnd: 7,
      period_type: "absolute",
      period_basis: "fiscal",
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.periodRange && changes.periodRange.currentValue) {
      const from = this.periodRange[0];
      const to = this.periodRange[1];
      this.defaultPeriodObj = { ...this.defaultPeriodObj };
      this.periodObj = {
        ...this.periodObj,
        period: getSelectedPeriods(this.defaultPeriodObj, false),
        periodStart: from,
        periodEnd: to,
        period_basis:
          getSelectedPeriodBasis(this.defaultPeriodObj.basis) === "cal"
            ? "calendar"
            : "fiscal",
        period_type: getPeriodTypeDataId(this.defaultPeriodObj),
      };
    }
  }

  periodSettingsChange(param) {
    const { updatedPeriodData, periodUserSettingData } = param;
    const selectedPeriodList = getSelectedPeriods(
      param.updatedPeriodData,
      false,
    );
    const periodType = getPeriodTypeDataId(updatedPeriodData);
    const basisValue =
      getSelectedPeriodBasis(updatedPeriodData.basis) === "cal"
        ? "calendar"
        : "fiscal";

    this.periodObj.period = selectedPeriodList;
    this.periodObj.period_basis = basisValue;
    this.periodObj.period_type = periodType;
    this.periodObj.periodStart = periodUserSettingData.from;
    this.periodObj.periodEnd = periodUserSettingData.to;
    this.defaultPeriodObj = updatedPeriodData;
    this.emitOutput("period");
  }

  updateDataView($event) {
    this.dataView = { view_by: $event.viewBy, revision: $event.revision };
    this.emitOutput("dataView");
  }

  onCurrencyChange(currency) {
    this.selectedCurrency = currency;
    this.emitOutput("currency");
  }

  emitOutput(filterName) {
    this.dataSettingsChanged.emit({
      dataSettings: {
        currency: this.selectedCurrency === "Base" ? "" : this.selectedCurrency,
        periodData: { ...this.periodObj },
        view_by: this.dataView.view_by,
        revision: this.dataView.revision,
      },
      defaultPeriodObj: { ...this.defaultPeriodObj },
      filterName: filterName,
    });
  }

  // onCascaderValueChange(value: any) {
  //   this.cascaderValueChange.emit(value); // Emit value to parent
  // }
  handleOnReset() {
    this.onReset.emit();
  }
}
